export default function titleCase(string) {
  return string ? string.toLowerCase().split(' ').map(function(word) {
    return word.replace(word[0], word[0] ? word[0].toUpperCase() : "");
  }).join(' ') : "";
}

export function upperCaseFirstWord(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
